import api from './api';

export interface BidCycleItem {
  fluxoProcessosEtapas: any[];
}

export interface BidCyclePendencias{
  bidCyclePaiId: string;
  pendencias: string[];
}

export const getAll = () => api.get<BidCycleItem[]>('bidCycle');
export const update = (value: any) => api.put('bidCycle', value);
export const excluir = (id: string) => api.delete(`bidCycle/${id}`);
export const getInfoDemanda = (values: any) =>
  api.post('bidCycle/GetInfoDemanda', values, { disableNotification: true });
export const getBidPendencias = () => api.get<BidCyclePendencias[]>(`bidCycle/GetBidPendencias`);